import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Col, Row, Button, Spinner } from "reactstrap";
import api, { baseURL } from "../../Axios";
import Swal from "sweetalert2";

const UpdateDocument = () => {
  const { id } = useParams();
  const history = useHistory();

  const [aadharFiles, setAadharFiles] = useState({
    front: null,
    back: null,
  });

  const [aadharPreviews, setAadharPreviews] = useState({
    front: null,
    back: null,
  });

  const [houseFiles, setHouseFiles] = useState({
    img1: null,
    img2: null,
    img3: null,
    img4: null,
  });

  const [housePreviews, setHousePreviews] = useState({
    img1: null,
    img2: null,
    img3: null,
    img4: null,
  });

  const [horoscopeFile, setHoroscopeFile] = useState(null);
  const [horoscopePreview, setHoroscopePreview] = useState(null);

  const [loading, setLoading] = useState({
    aadhar: false,
    education: false,
    houseImage: false,
    horoscopeImage: false,
  });

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Fetch existing documents
  useEffect(() => {
    api
      .get("/admin/userProfile/profileView?userId=" + id)
      .then((res) => {
        const data = res.data;

        // Set existing horoscope image
        if (data.horoscope && data.horoscope.horoscopeImage) {
          setHoroscopePreview(baseURL + data.horoscope.horoscopeImage);
        }

        // Set existing aadhar images
        if (data.document && data.document.aadharFront) {
          setAadharPreviews(function (prev) {
            return {
              ...prev,
              front: baseURL + data.document.aadharFront,
            };
          });
        }
        if (data.document && data.document.aadharBack) {
          setAadharPreviews(function (prev) {
            return {
              ...prev,
              back: baseURL + data.document.aadharBack,
            };
          });
        }

        // Set existing house images
        if (data.house && data.house.houseImage1) {
          setHousePreviews(function (prev) {
            return { ...prev, img1: baseURL + data.house.houseImage1 };
          });
        }
        if (data.house && data.house.houseImage2) {
          setHousePreviews(function (prev) {
            return { ...prev, img2: baseURL + data.house.houseImage2 };
          });
        }
        if (data.house && data.house.houseImage3) {
          setHousePreviews(function (prev) {
            return { ...prev, img3: baseURL + data.house.houseImage3 };
          });
        }
        if (data.house && data.house.houseImage4) {
          setHousePreviews(function (prev) {
            return { ...prev, img4: baseURL + data.house.houseImage4 };
          });
        }
      })
      .catch(function (err) {
        console.error("Error fetching documents:", err);
      });
  }, [id]);

  // Handle Aadhar Upload
  const handleAadharUpload = function () {
    if (!aadharFiles.front && !aadharFiles.back) {
      Swal.fire(
        "Error",
        "Please select at least one Aadhar image to update",
        "error"
      );
      return;
    }

    setLoading(function (prev) {
      return { ...prev, aadhar: true };
    });

    var formData = new FormData();
    if (aadharFiles.front) formData.append("images", aadharFiles.front);
    if (aadharFiles.back) formData.append("images", aadharFiles.back);

    api
      .post("/admin/userProfile/aadharImage?userId=" + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (res) {
        if (!isMounted.current) return;
        Swal.fire(
          "Success",
          res.data.data || "Updated successfully!",
          "success"
        );
        // Update previews with new images
        if (aadharFiles.front) {
          setAadharPreviews(function (prev) {
            return { ...prev, front: URL.createObjectURL(aadharFiles.front) };
          });
        }
        if (aadharFiles.back) {
          setAadharPreviews(function (prev) {
            return { ...prev, back: URL.createObjectURL(aadharFiles.back) };
          });
        }
        setAadharFiles({ front: null, back: null });
      })
      .catch(function () {
        Swal.fire("Error", "Failed to update Aadhar", "error");
      })
      .finally(function () {
        if (isMounted.current)
          setLoading(function (prev) {
            return { ...prev, aadhar: false };
          });
      });
  };

  // Handle House Image Upload
  const handleHouseUpload = function () {
    var files = Object.values(houseFiles).filter(function (f) {
      return f;
    });
    if (files.length === 0) {
      Swal.fire("Error", "Please select at least one house image", "error");
      return;
    }

    setLoading(function (prev) {
      return { ...prev, houseImage: true };
    });

    var formData = new FormData();
    files.forEach(function (file) {
      formData.append("images", file);
    });

    api
      .post("/admin/userProfile/houseImage?userId=" + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (res) {
        if (!isMounted.current) return;
        Swal.fire(
          "Success",
          res.data.data || "Updated successfully!",
          "success"
        );
        // Update previews
        Object.keys(houseFiles).forEach(function (key) {
          if (houseFiles[key]) {
            setHousePreviews(function (prev) {
              return { ...prev, [key]: URL.createObjectURL(houseFiles[key]) };
            });
          }
        });
        setHouseFiles({ img1: null, img2: null, img3: null, img4: null });
      })
      .catch(function () {
        Swal.fire("Error", "Failed to update house images", "error");
      })
      .finally(function () {
        if (isMounted.current)
          setLoading(function (prev) {
            return { ...prev, houseImage: false };
          });
      });
  };

  // Handle Horoscope Upload
  const handleHoroscopeUpload = function (e) {
    var file = e.target.files[0];
    if (!file) return;

    setHoroscopeFile(file);
    setLoading(function (prev) {
      return { ...prev, horoscopeImage: true };
    });

    var formData = new FormData();
    formData.append("image", file);

    api
      .post("/admin/userProfile/horoscopeImage?userId=" + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function (res) {
        if (!isMounted.current) return;
        Swal.fire(
          "Success",
          res.data.data || "Updated successfully!",
          "success"
        );
        setHoroscopePreview(URL.createObjectURL(file));
      })
      .catch(function () {
        Swal.fire("Error", "Failed to update horoscope", "error");
      })
      .finally(function () {
        if (isMounted.current)
          setLoading(function (prev) {
            return { ...prev, horoscopeImage: false };
          });
      });
  };

  const handleGoBack = function () {
    history.goBack();
  };

  return (
    <div className="content">
      <Row>
        <Col xs={12} md={12}>
          <div className="page-title">
            <div className="float-left">
              <h1 className="title">Update Documents</h1>
            </div>
          </div>

          <div className="col-12">
            <section className="box">
              <div className="content-body">
                {/* Horoscope Image */}
                <div
                  className="form-outline mb-4 p-3"
                  style={{ border: "solid 1px", borderRadius: "5px" }}
                >
                  <label className="form-label">
                    <h5 style={{ paddingBottom: "5px" }}>Horoscope Image</h5>
                  </label>
                  <p>(File type: JPG, JPEG, PNG only)</p>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div
                      style={{
                        position: "relative",
                        width: "150px",
                        height: "150px",
                        border: "2px dashed #ddd",
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      {horoscopePreview ? (
                        <>
                          <img
                            src={horoscopePreview}
                            alt="Preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <label
                            htmlFor="horoscope-input-update"
                            style={{
                              position: "absolute",
                              bottom: "5px",
                              right: "5px",
                              background: "rgba(0,0,0,0.7)",
                              border: "none",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              color: "white",
                              fontSize: "14px",
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                            <input
                              type="file"
                              id="horoscope-input-update"
                              accept=".jpg,.jpeg,.png"
                              style={{ display: "none" }}
                              onChange={handleHoroscopeUpload}
                            />
                          </label>
                        </>
                      ) : (
                        <label
                          htmlFor="horoscope-input"
                          style={{
                            cursor: "pointer",
                            textAlign: "center",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            fontSize: "12px",
                          }}
                        >
                          <i
                            className="fa fa-upload"
                            style={{ fontSize: "24px", color: "#6c757d" }}
                          ></i>
                          <div>Upload</div>
                          <input
                            type="file"
                            id="horoscope-input"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={handleHoroscopeUpload}
                          />
                        </label>
                      )}
                    </div>
                    {loading.horoscopeImage && (
                      <div className="mt-2 d-flex align-items-center">
                        <Spinner size="sm" color="primary" /> Uploading...
                      </div>
                    )}
                  </div>
                </div>

                {/* Aadhar Upload */}
                <div
                  className="form-outline mb-4 p-3"
                  style={{ border: "solid 1px", borderRadius: "5px" }}
                >
                  <label className="form-label">
                    <h5 style={{ paddingBottom: "5px" }}>
                      ID Proof - Aadhar Card
                    </h5>
                  </label>
                  <p>(Upload Front & Back - JPG, JPEG, PNG only)</p>
                  <div style={{ display: "flex", gap: "20px" }}>
                    {["front", "back"].map(function (key) {
                      return (
                        <div
                          key={key}
                          style={{
                            position: "relative",
                            width: "150px",
                            height: "150px",
                            border: "2px dashed #ddd",
                            borderRadius: "8px",
                            backgroundColor: "#f8f9fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          {aadharFiles[key] ? (
                            <>
                              <img
                                src={URL.createObjectURL(aadharFiles[key])}
                                alt={key + " preview"}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                type="button"
                                onClick={function () {
                                  setAadharFiles(function (prev) {
                                    return { ...prev, [key]: null };
                                  });
                                }}
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  background: "rgba(0,0,0,0.7)",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  color: "white",
                                  fontSize: "12px",
                                }}
                              >
                                &times;
                              </button>
                            </>
                          ) : aadharPreviews[key] ? (
                            <>
                              <img
                                src={aadharPreviews[key]}
                                alt={key + " preview"}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <label
                                htmlFor={"aadhar-" + key + "-update"}
                                style={{
                                  position: "absolute",
                                  bottom: "5px",
                                  right: "5px",
                                  background: "rgba(0,0,0,0.7)",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "30px",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  color: "white",
                                  fontSize: "14px",
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                                <input
                                  type="file"
                                  id={"aadhar-" + key + "-update"}
                                  accept=".jpg,.jpeg,.png"
                                  style={{ display: "none" }}
                                  onChange={function (e) {
                                    var file = e.target.files[0];
                                    if (!file) return;
                                    setAadharFiles(function (prev) {
                                      return { ...prev, [key]: file };
                                    });
                                  }}
                                />
                              </label>
                            </>
                          ) : (
                            <label
                              htmlFor={"aadhar-" + key}
                              style={{
                                cursor: "pointer",
                                textAlign: "center",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                fontSize: "12px",
                              }}
                            >
                              <i
                                className="fa fa-upload"
                                style={{ fontSize: "24px", color: "#6c757d" }}
                              ></i>
                              <div>{key === "front" ? "Front" : "Back"}</div>
                              <input
                                type="file"
                                id={"aadhar-" + key}
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={function (e) {
                                  var file = e.target.files[0];
                                  if (!file) return;
                                  setAadharFiles(function (prev) {
                                    return { ...prev, [key]: file };
                                  });
                                }}
                              />
                            </label>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <Button
                    color="primary"
                    onClick={handleAadharUpload}
                    disabled={loading.aadhar}
                    className="mt-3"
                  >
                    {loading.aadhar ? <Spinner size="sm" /> : "Update Aadhar"}
                  </Button>
                </div>

                {/* House Images */}
                <div
                  className="form-outline mb-4 p-3"
                  style={{ border: "solid 1px", borderRadius: "5px" }}
                >
                  <label className="form-label">
                    <h5 style={{ paddingBottom: "5px" }}>House Images</h5>
                  </label>
                  <p>(Upload 4 images separately - JPG, JPEG, PNG only)</p>
                  <div className="d-flex flex-wrap gap-3">
                    {["img1", "img2", "img3", "img4"].map(function (key, index) {
                      return (
                        <div
                          key={key}
                          style={{
                            position: "relative",
                            width: "150px",
                            height: "150px",
                            border: "2px dashed #ddd",
                            borderRadius: "8px",
                            backgroundColor: "#f8f9fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          {houseFiles[key] ? (
                            <>
                              <img
                                src={URL.createObjectURL(houseFiles[key])}
                                alt={"House " + (index + 1)}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                type="button"
                                onClick={function () {
                                  setHouseFiles(function (prev) {
                                    return { ...prev, [key]: null };
                                  });
                                }}
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  background: "rgba(0,0,0,0.7)",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  color: "white",
                                  fontSize: "12px",
                                }}
                              >
                                &times;
                              </button>
                            </>
                          ) : housePreviews[key] ? (
                            <>
                              <img
                                src={housePreviews[key]}
                                alt={"House " + (index + 1)}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <label
                                htmlFor={"house-" + key + "-update"}
                                style={{
                                  position: "absolute",
                                  bottom: "5px",
                                  right: "5px",
                                  background: "rgba(0,0,0,0.7)",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "30px",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  color: "white",
                                  fontSize: "14px",
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                                <input
                                  type="file"
                                  id={"house-" + key + "-update"}
                                  accept=".jpg,.jpeg,.png"
                                  style={{ display: "none" }}
                                  onChange={function (e) {
                                    var file = e.target.files[0];
                                    if (!file) return;
                                    setHouseFiles(function (prev) {
                                      return { ...prev, [key]: file };
                                    });
                                  }}
                                />
                              </label>
                            </>
                          ) : (
                            <label
                              htmlFor={"house-" + key}
                              style={{
                                cursor: "pointer",
                                textAlign: "center",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                fontSize: "12px",
                              }}
                            >
                              <i
                                className="fa fa-upload"
                                style={{ fontSize: "24px", color: "#6c757d" }}
                              ></i>
                              <div>Image {index + 1}</div>
                              <input
                                type="file"
                                id={"house-" + key}
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={function (e) {
                                  var file = e.target.files[0];
                                  if (!file) return;
                                  setHouseFiles(function (prev) {
                                    return { ...prev, [key]: file };
                                  });
                                }}
                              />
                            </label>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <Button
                    color="primary"
                    onClick={handleHouseUpload}
                    disabled={loading.houseImage}
                    className="mt-2"
                  >
                    {loading.houseImage ? (
                      <Spinner size="sm" />
                    ) : (
                      "Update House Images"
                    )}
                  </Button>
                </div>

                {/* Go Back Button */}
                <div className="mt-4">
                  <Button
                    style={{
                      background: "#000",
                      border: "none",
                      padding: "10px 30px",
                    }}
                    onClick={handleGoBack}
                  >
                    <i className="fa fa-arrow-left mr-2"></i>
                    Go Back
                  </Button>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpdateDocument;
